import { Flex, Image } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import download_android_en from 'assets/images/download-app/download_android_en.webp';
import download_android_ru from 'assets/images/download-app/download_android_ru.webp';
import download_android_de from 'assets/images/download-app/download_android_de.webp';
import download_ios_en from 'assets/images/download-app/download_ios_en.svg';
import download_ios_ru from 'assets/images/download-app/download_ios_ru.svg';
import download_ios_de from 'assets/images/download-app/download_ios_de.svg';

import useIsMobile from 'hooks/useIsMobile';

const AppButtons = () => {
  const { i18n } = useTranslation();
  const isMobile = useIsMobile();

  let androidSrc, iosSrc;

  switch (i18n.language) {
    case 'en':
      androidSrc = download_android_en;
      iosSrc = download_ios_en;
      break;
    case 'ru':
      androidSrc = download_android_ru;
      iosSrc = download_ios_ru;
      break;
    case 'de':
      androidSrc = download_android_de;
      iosSrc = download_ios_de;
      break;
    default:
      androidSrc = download_android_en;
      iosSrc = download_ios_en;
  }

  return (
    <Flex gap={10} align="center">
      <a
        target="_blank"
        rel="noreferrer"
        href="https://play.google.com/store/apps/details?id=com.medicusunion.doctorapp"
      >
        <Image
          preview={false}
          src={androidSrc}
          alt="Google Play"
          width={isMobile ? 107 : 140}
          height={isMobile ? 46 : 57}
        />
      </a>
      <a
        target="_blank"
        rel="noreferrer"
        href="https://apps.apple.com/am/app/medicusunion-pro-for-doctors/id1635403462"
      >
        <Image
          preview={false}
          alt="App Store"
          src={iosSrc}
          width={isMobile ? 107 : 134}
          height={isMobile ? 36 : 45}
        />
      </a>
    </Flex>
  );
};

export default AppButtons;
